module.exports = __webpack_public_path__ + "img/green_dots.94a5252d.png";